import React from 'react';
import '../../../assets/css/announcement.scss';

interface Props {
  date?: string;
  title: string;
  description: string;
  url?: string;
}

const Announcement = ({ date, title, description, url }: Props) => (
  <div className="announcement" data-testid="announcement">
    {date && (
      <div className="announcement-date-container">
        <span className="announcement-date">{date}</span>
      </div>
    )}
    <div className="announcement-content">
      <span className="announcement-title">{title}</span>
      <p
        className="announcement-description"
        /* `description` has been sanitized by our backend */
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {url && (
        <a className="announcement-url" href={url} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      )}
    </div>
  </div>
);

export default Announcement;
